import { Card, CardContent, cn } from '@1trading/react';

interface MetricTileProps {
  label: string;
  value: string;
  hint?: string;
  isHeadline?: boolean;
  className?: string;
}

export const MetricTile = ({ label, value, hint, isHeadline = false, className }: MetricTileProps) => (
  <Card className={cn(isHeadline && 'border-primary/30 bg-primary/5', className)}>
    <CardContent className="flex h-full flex-col gap-1 pt-4 pb-4">
      <span className="text-muted-foreground text-xs uppercase tracking-wide">{label}</span>
      <span className={cn('font-semibold tabular-nums', isHeadline ? 'text-4xl' : 'text-2xl')}>{value}</span>
      {hint ? <span className="text-muted-foreground text-xs">{hint}</span> : null}
    </CardContent>
  </Card>
);
MetricTile.displayName = 'MetricTile';
